<div class="forgot-password-container">
    <h2>Forgot Password</h2>
    <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">
        <mat-form-field appearance="outline">
            <mat-label>Email</mat-label>
            <input matInput type="email" formControlName="email" required
                name="email" autocomplete="username" autocapitalize="off"
                spellcheck="false" inputmode="email">
            <mat-error *ngIf="forgotPasswordForm.get('email')?.invalid">Please enter a valid email</mat-error>
        </mat-form-field>
        <app-turnstile #challenge (tokenChange)="turnstileToken = $event"></app-turnstile>
        <button mat-raised-button color="primary" type="submit"
            [disabled]="forgotPasswordForm.invalid || !challengeReady">Reset Password</button>
    </form>
    <div class="login-link">
        Remember your password? <a (click)="onLoginClick()">Login</a>
    </div>
</div>